import type { RouteObject } from "react-router-dom";
import { createBrowserRouter } from "react-router-dom";
import { wrapCreateBrowserRouter } from "@sentry/react";

import { App } from "../App";

import { loginLoader, protectedLoader } from "./authLoaders";
import { routes } from "./routes";

// import { authPath } from "./auth/path";
import type { IExtendedRouteObject } from "@routes/types.ts";
import { ErrorPage } from "@pages/errorPage";
import { useUIStore } from "@/stores/uiStore";
import type { IRole } from "@/interfaces";
import { Root } from "@/root";
import { path } from "@routes/path.ts";

const withLayout: IExtendedRouteObject[] = [
  {
    route: {
      path: "/",
      element: <App />,
      loader: ({ request }) => {
        useUIStore.getState().setPage(request, "mainPage", null, "index");
        return {};
      },
    },
    permissions: "all",
  },
  ...routes,
];

const getExtractRolesRoute = (
  role: IRole | null,
  routes: IExtendedRouteObject[],
) => {
  return routes
    ?.filter(
      (route) =>
        role === null ||
        (route.permissions === "all"
          ? true
          : route.permissions?.includes(role)) ||
        route.route.path === "/",
    )
    ?.map((route) => route.route);
};

const outsideRoutes: RouteObject[] = [
  {
    path: path.pwaPath.install(),
    lazy: () => import("@/pages/commonPages/pwa/publicPage"),
    loader: ({ request }) => {
      useUIStore.getState().setPage(request, "pwa", null, "index");
      return null;
    },
    errorElement: <ErrorPage />,
  },
  {
    path: "/auth",
    lazy: () => import("@pages/authManagement/authManagement"),
    loader: (props) => {
      useUIStore.getState().setPage(props?.request, "login", null, "edit");
      return loginLoader(props);
    },
    errorElement: <ErrorPage />,
  },
  {
    path: path.authManagement.auth.route,
    lazy: () => import("@pages/authManagement/authManagement"),
    loader: (props) => {
      useUIStore.getState().setPage(props?.request, "login", null, "edit");
      return loginLoader(props);
    },
    errorElement: <ErrorPage />,
  },
];
const sentryCreateBrowserRouter = wrapCreateBrowserRouter(createBrowserRouter);

export const getRouter = (role: IRole | null) => {
  return sentryCreateBrowserRouter([
    {
      path: "/",
      element: <Root />,
      children: [
        ...outsideRoutes,
        {
          lazy: () => import("@pages/Layout"),
          children: getExtractRolesRoute(role, [...withLayout]),
          loader: protectedLoader,
        },
      ],
      // errorElement: <ErrorPage />,
    },
  ]);
};
